import React, {useState} from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

const ColorPicker = (props) => {

  const [color, setColor]= useState(props.color)
  const[display, setDisplay] = useState(false)

  const handleClick = () => {
    setDisplay(!display)
  };

  const handleClose = () => {
    setDisplay(false)
  };

  const handleChange = (color) => {
    setColor(color.hex);
    props.setColor(color.hex);
  };

  const styles = reactCSS({
    'default': {
      color: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: `${color}`,
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  });

  return (
      <div>
        <div style={ styles.swatch } onClick={ handleClick }>
          <div style={ styles.color } />
        </div>
        { display ? <div style={ styles.popover }>
          <div style={ styles.cover } onClick={ handleClose }/>
          <SketchPicker color={color} onChange={ handleChange } />
        </div> : null }
      </div>
  );
}

export default ColorPicker